import commandEngine from './CommandEngine';
import appBarEngine from '../../../AppBar/AppBarEngine';

/**
 * Registers the /appbar command with the CommandEngine.
 * Call once at module load from YourLibraryTab.
 *
 * /appbar hide — hides the AppBar
 * /appbar show — shows the AppBar
 */
export function registerAppBarCommand() {
    commandEngine.register('/appbar', {
        hint: 'Show or hide AppBar',
        params: [{ name: 'action', hints: ['hide', 'show'] }],
        handler: ([action]) => {
            if (action === 'hide') appBarEngine.hide();
            else if (action === 'show') appBarEngine.show();
        },
    });
}
